import { atom } from "recoil";

export const ListCandidateByOpportunityID = atom({
    key: "ListCandidateByOpportunityID",
    default: [],
});